// extracted by mini-css-extract-plugin
export default {"pageWrapper":"style_pageWrapper__3O-Z8","userInfo":"style_userInfo__cG0BT","carsContainer":"style_carsContainer__iSjbT","pagination":"style_pagination__yYgX1"};